import React, { Component } from 'react';

import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';

import Title from './Title.jsx';
import Header from './Header.jsx';
import Table from './Table.jsx';

class UsuariosPorPerfl extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.getScreenData(id, this.props.currentScope, this.props.executionContext);
    }

    componentWillUnmount() {
        this.props.resetStateUsrPorPerf();
    }

    render() {
        let component = null;
        let spinner = null;

        if (this.props.data.isFetching == true)
            spinner = <div className="loading">Loading&#8230;</div>

        if (this.props.data.isFetching == true)
            return spinner;

        if (this.props.data.functions != undefined && this.props.data.functions.length > 0) {

            let functions = this.props.data.functions;

            if (functions.Consulta == true) {
                if (this.props.data.usuarios == undefined)
                    return spinner;

                component = (
                    <div className="container-fluid concierge">
                        {spinner}

                        <Title titulo1={'Usuarios del perfil '}
                            titulo2={this.props.data.title2} />

                        <Header
                            functions={this.props.data.functions}
                            usuarios={this.props.data.usuarios}
                            searchUser={this.props.searchUser}
                            usuariosFiltrados={this.props.data.usuariosFiltrados}
                            setActivosCheckbox={this.props.setActivosCheckbox}
                            setBloqueadosCheckbox={this.props.setBloqueadosCheckbox}
                            setEliminadosCheckbox={this.props.setEliminadosCheckbox}
                            setMotivoBloqueo={this.props.setMotivoBloqueo}
                            setUserState={this.props.setUserState}
                        />

                        <Table
                            functions={this.props.data.functions}
                            currentUser={this.props.data.currentUser}
                            usuarios={this.props.data.usuarios}
                            usuariosFiltrados={this.props.data.usuariosFiltrados}
                            columnIndex={this.props.data.columnIndex}
                            column={this.props.data.column}
                            orderColumn={this.props.orderColumn}
                            setAllCheckbox={this.props.setAllCheckbox}
                            allCheckboxFilter={this.props.data.allCheckboxFilter}
                            setCheckbox={this.props.setCheckbox}
                            perfilId={this.props.match.params.id}
                            setUserState={this.props.setUserState}
                        />
                    </div>
                );
            } else {
                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                return (
                    <div>
                        {spinner}
                        <GenericErrorScreen data={values} />
                    </div>);
            }

            return (component);
        } else {
            return null;
        }
    }
}

export default UsuariosPorPerfl;